<template>
	<DialogFormDialog
		ref="dialog"
		:strings="strings"
		:max-width="540"
		@reset="reset"
	>
		<v-autocomplete
			v-model="values.communities"
			:items="items"
			:rules="rules"
			:label="strings.nameLabel"
			chips
			clearable
			multiple
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import strings from "@/utils/strings";

const initData = () => ({
	strings: strings.project.dialogs.addCommunities,

	values: { communities: [] },
	rules: [v => !!v.length || "You must select at least one"],
});

export default {
	props: {
		communities: {
			type: Array,
			required: true,
		},
	},

	data: initData,

	computed: {
		...mapGetters({ allCommunities: "communities/items" }),

		items() {
			const existingCommunityIds = _.map(this.communities, "id");

			return _.chain(this.allCommunities)
				.filter(community => !_(existingCommunityIds).includes(community.id))
				.map(community => ({
					text: community.name,
					value: community.id,
				}))
				.sortBy("text")
				.value();
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		this.pop = this.$refs.dialog.pop;
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},
	},
};
</script>
